import { PageHeader } from "../components/PageHeader";
import { Card, Lead, P, H3, CheckList } from "../components/Section";
import { openLink, haptic } from "../lib/telegram";

export default function FinKeeper() {
  function go(url: string) {
    haptic("light");
    openLink(url);
  }
  return (
    <div className="pb-10">
      <PageHeader
        eyebrow="Готовый продукт"
        title="FinKeeper"
        subtitle="Простой финансовый учёт для собственника. Без бухгалтерии, без таблиц, без боли."
        icon="💰"
        iconColor="green"
      />

      <div className="px-5 mt-3 space-y-3">
        <Card>
          <Lead>
            Хочешь оцифровать бизнес и наконец понимать, где деньги — но не хочешь учить бухгалтерию?
          </Lead>
          <P>
            Знакомая история: деньги вроде есть, прибыль непонятно где. ДДС и П&Л звучат как ругательства.
            Excel-таблицы заброшены через две недели. «Систему учёта» начинали внедрять трижды — каждый раз бросали.
          </P>
        </Card>

        <Card>
          <H3>FinKeeper решает эту задачу</H3>
          <CheckList items={[
            "Простой кабинет для собственника, а не для бухгалтера",
            "ДДС и П&Л строятся автоматически по операциям",
            "Операции вносятся через Telegram-бот — в пару кнопок, не открывая браузер",
            "РНП — таблица еженедельных показателей с планом и фактом",
            "Сводный дашборд: выручка, прибыль, маржа, Cash Flow — в одном экране",
            "Справочники под структуру твоего бизнеса (счета, проекты, контрагенты)",
          ]} />
        </Card>

        <Card>
          <H3>Для кого</H3>
          <P>
            Малый бизнес до 20 человек. Тем, кому нужна ясность по деньгам без курсов по финансам.
            Тем, кто уже пробовал ПланФакт, Adesk или Excel — и бросал.
          </P>
        </Card>

        <div className="ios-callout">
          🚀 7 дней бесплатно — карта не нужна
        </div>

        <div className="space-y-3 pt-2">
          <button className="ios-btn ios-btn-primary" onClick={() => go("https://finkeeper.biz/app?reg=1")}>
            🚀 Попробовать бесплатно
          </button>
          <button className="ios-btn ios-btn-ghost" onClick={() => go("https://finkeeper.biz/app?demo=1")}>
            👁 Посмотреть демо-кабинет
          </button>
        </div>

        <div className="text-center text-[13px] text-muted pt-2">
          Это готовый продукт — никаких заявок, регистрируйся и пользуйся.
        </div>
      </div>
    </div>
  );
}
